import { Responsive, WidthProvider } from "react-grid-layout";
import DashboardContainer from "./DashboardContainer";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

function AdminStatisticsManagement() {
  const indexes = [67, 38, 39, 40, 68];
  const defaultLayout = {
    lg: [
      {
        w: 10,
        h: 12,
        x: 0,
        y: 0,
        i: "0",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 0,
        y: 12,
        i: "1",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 5,
        y: 12,
        i: "2",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 0,
        y: 23,
        i: "3",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 12,
        x: 5,
        y: 23,
        i: "4",
        moved: false,
        static: false,
      },
    ],
    xs: [
      {
        w: 10,
        h: 12,
        x: 0,
        y: 0,
        i: "0",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 0,
        y: 12,
        i: "1",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 5,
        y: 12,
        i: "2",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 0,
        y: 23,
        i: "3",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 10,
        x: 5,
        y: 23,
        i: "4",
        moved: false,
        static: false,
      },
    ],
  };

  return (
    <DashboardContainer
      name={"AdminStatisticsManagement"}
      indexes={indexes}
      defaultLayout={defaultLayout}
    />
  );
}

export default AdminStatisticsManagement;
